import {Component, inject, OnInit} from '@angular/core';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {AuthenticationService} from '../../authentication.service';
import {VerifyDto} from '../../dtos/verify.dto';
import {ErrorService} from '../../../../core/services/error.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {take} from 'rxjs';

@Component({
  selector: 'app-grant-access',
  imports: [
    TextButton,
    TranslocoPipe,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule
  ],
  templateUrl: './grant-access.component.html',
  styleUrl: './grant-access.component.scss'
})
export class GrantAccessComponent implements OnInit {
  authenticationService: AuthenticationService = inject(AuthenticationService);
  translocoService = inject(TranslocoService);
  errorService = inject(ErrorService);
  error?: string;
  urlParameter?: string;
  verificationCode: FormControl = new FormControl('');

  constructor(private activatedRoute: ActivatedRoute, private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.translocoService.selectTranslation().pipe(take(1)).subscribe(() => {
      this.urlParameter = this.activatedRoute.snapshot.queryParams['verificationCode'];
      if (this.urlParameter) {
        this.verificationCode.setValue(this.urlParameter);
        this.grantAccess();
      }
    });
  }

  grantAccess() {
    const verifyDto: VerifyDto = {verificationCode: this.verificationCode.value};

    this.authenticationService.grantAccess(verifyDto).subscribe({
      next: () => {
        this.error = undefined;
        this.snackBar.open(this.translocoService.translate('grantAccess.succeeded'), 'OK', {
          duration: 3000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom'
        });
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 404) {
          this.error = this.translocoService.translate('error.verificationCode');
          return;
        }

        this.error = undefined;
        this.errorService.handleError(error, this.translocoService.translate('error.title.grantAccess'));
      }
    })
  }
}
